<template>
  <b-container
    v-if="service !== null"
    fluid 
    class="p-0"
  >
    <b-card-group>
      <b-card 
        v-for="(count, type,index) in aantalUnitsPerOnderhoudscategorie" 
        :key="index"
      >
        <div class="h4 m-0">
          {{ count }}
        </div>
        <small>{{ type }}</small>
      </b-card>
    </b-card-group>
  
    <b-table 
      :fields="[
        'adres',
        'stopplaatsen',
        'advies',
        {
          key:'korsteDuurOnderhoud',
        },
        {
          key:'aantalOnderhoud',
        }
      ]"
      :items="onderhoudOverzichtPerUnit.filter((u) => ['B'].includes(u.oh))"
      small
      bordered
    >
      <template #cell(advies)="row">
        {{ (Number(row.item.stopplaatsen) * Number(aantalonderhoud)).toFixed(1) }} beurten
      </template>
      <template #cell(korsteDuurOnderhoud)="row">
        {{ row.item.korsteDuurOnderhoud }}
      </template>
      <template #cell(aantalOnderhoud)="row">
        {{ row.item.aantalOnderhoud }}
      </template>
    </b-table>

    <b-table 
      :fields="[{
        key:'label',
        label: 'Titel',
      },{
        key: 'filters.category',
        label: 'Categorie',
      }]
        .concat(quarterFields).concat([{
          key:'gemiddelde',
          label:'Totaal'
        }])"
      :items="kpiService"
      striped
      hover
      bordered
    >
      <template #cell(label)="row">
        {{ row.item.label }} {{ row.item.total }} units<br>
      </template>
      <template #cell(quarters.kw0)="row" />
      <template #cell(quarters.kw1)="row" />
      <template #cell(quarters.kw2)="row" />
      <template #cell(quarters.kw3)="row" />
    </b-table>
  </b-container>
</template>
<script>
import { serviceMixin } from '@/mixins/serviceMixin.js';
import moment from 'moment';

export default {
  name: 'KpiKwartalen',
  mixins: [serviceMixin],
  props: {
    units: {
      type: Array,
      required: true,
    },
    service: {
      type: Array,
      required: true,
    },
    prestatie: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  data() {
      return  {
        maxaantal: 4,
        aantalonderhoud: 0.2,
        ureninjaar: 8760,
        keys : {
          'reactietijd': 'r' ,
          'oplostijd': 'g',
          'stilstandtijd': 'm',
          'telling': 'c'
        },
        report: [],
        types: [ 'MAINTENANCE', 'INCIDENT', 'REPAIR', 'ASSISTANCE INSPECTION', 'CHECK'],
        kpi: {
            bsi: (input,filter) => input.filter((i) => 
              [...filter].includes(i.t)).reduce((a, b) => a + b[this.keys.oplostijd], 0) / 60,
            cnt: (input,filter) => input.filter((i) => 
              [...filter].includes(i.t)).length,
        },
      }
  },
  computed: {
      quarters() {
        var quarters = [];
        var d = new Date();
        var q = Math.floor((d.getMonth() + 3) / 3);
        var y = d.getFullYear();
        for (let i = 0; i < 4; i++) {
          quarters.push({
            quarter: q,
            year: y,
          });
          q--;
          if (q == 0) {
            q = 4;
            y--;
          }
        }
        return quarters.reverse();
      },
      onderhoudOverzichtPerUnit() {
        var getPerUnitCount = this.getPerUnitCount(["MAINTENANCE"], null, null);
        var getPerUnitValues = this.getPerUnitValues("m",["MAINTENANCE"], null, null);
        return this.units.map(u => {
          return {
            adres: u.adres,
            oh: u.oh,
            stopplaatsen: u.config.ast,
            aantalOnderhoud: getPerUnitCount[u.id] || 0,
            alleOnderhoud: getPerUnitValues[u.id],
            korsteDuurOnderhoud: Math.min(...getPerUnitValues[u.id] || [0]),
          }
        })
      },  
      stilstandOverzicht() {
        // stilstand totaal
        var unitValues = this.getPerUnitValues("m",null,null,null);
        return this.units.map(u => {
          return {
            adres: u.adres,
            oh: u.oh,
            stilstand: unitValues[u.id],
            totaal: (unitValues[u.id] || []).reduce((a, b) => a + b, 0),
            beschikbaarheidPercentage: (((this.ureninjaar - (unitValues[u.id] || []).reduce((a, b) => a + b, 0)) / this.ureninjaar)* 100).toFixed(0),
          }
        })
      },  
      aantalUnitsPerOnderhoudscategorie() {
        var oh = {};
        for (let i = 0; i < this.units.length; i++) {
          if (oh[this.units[i].oh] == undefined) {
            oh[this.units[i].oh] = 0;
          }
          oh[this.units[i].oh]++;
        }
        return oh;
      },
      quarterFields() {
        return this.quarters.map(function(q, index) { 
          return {
            ...q, 
            key: `quarters.kw${index}`,
            label: `Q${q.quarter} ${q.year}`
          }
        });
      }, 
      filteredService() {
        return this.service.filter(s => (s.p || this.prestatie == false));
      },  
      unitService() {
          return this.units.map(u => {
            var unitService = this.filteredService.filter(s => (s.u.id == u.id));
            var quarters = {
                kw0: this.kpi[this.type](this.quarterResult(unitService,this.quarters[0]),this.types),
                kw1: this.kpi[this.type](this.quarterResult(unitService,this.quarters[1]),this.types),
                kw2: this.kpi[this.type](this.quarterResult(unitService,this.quarters[2]),this.types),
                kw3: this.kpi[this.type](this.quarterResult(unitService,this.quarters[3]),this.types),
              };
            return {
              ...u,
              service: unitService,
              quarters: { ...quarters },
              _showDetails: false,
              gemiddelde: 
                (Object.values(quarters).reduce(function(r,n) { return r + n} )),
            }
          });
      },
      kpiService() {
        return this.report.map(kpi => {
          return {
            ...kpi
          }
        });
      },  
      maintenanceCount() {
          return this.service.filter(s => s.type == 'MAINTENANCE');
      },
    },
    methods: {
      getValuesTable(types,categorieen,ohcategorie,key) {
        var unitValues = this.getPerUnitValues(key,types,categorieen,ohcategorie);
        return this.units.filter((u) => ohcategorie.includes(u.oh)).map((u2) => {
            return {
              adres: u2.adres,
              oh: u2.oh,
              values: unitValues[u2.id] || [],
            }
        });
      },
      getSubSet(types,categorieen,ohcategorie) {
        return this.filteredService
          .filter(s => types == null || types.includes(s.t))
          .filter(s1 => categorieen == null || categorieen.includes(s1.c))
          .filter(s2 => ohcategorie == null || ohcategorie.includes(s2.o));
      },
      getPerUnitValues(value,types,categorieen,ohcategorie ) {
        var serviceSet = this.getSubSet(types,categorieen,ohcategorie);
        var valuesPerUnit = serviceSet.reduce((a, b) => {
          a[b.u.id] = (a[b.u.id] || []).concat(b[value]);
          return a;
        }, {});
        return valuesPerUnit;
      },
      getPerUnitCount( types,categorieen,ohcategorie ) {
        var serviceSet = this.getSubSet(types,categorieen,ohcategorie);
        var serviceCount = serviceSet.reduce((a, b) => {
          a[b.u.id] = (a[b.u.id] || 0) + 1;
          return a;
        }, {});
        return serviceCount;
      },
      getTotaalAantal(types,categorieen,ohcategorie) {
        var totaal = Object.values(this.getPerUnitCount(types,categorieen,ohcategorie)).reduce((a, b) => a + b, 0);
        return totaal
      },
      getVeelstoorders(records,maxaantal) {
          var overschrijdingen = Object.keys(records)
          .filter(key => records[key] > maxaantal)
          .reduce((obj, key) => {
            obj[key] = records[key];
            return obj;
          }, {});
          return Object.keys(overschrijdingen).length;
      },
      getGemiddeldeZonderOverschrijding(totaalaantal,records,maxaantal) {
        var serviceCountFiltered = Object.keys(records)
          .filter(key => records[key] <= maxaantal)
          .reduce((obj, key) => {
            obj[key] = records[key];
            return obj;
          }, {});

        var overschrijdingen = Object.keys(records)
        .filter(key => records[key] > maxaantal)
        .reduce((obj, key) => {
          obj[key] = records[key];
          return obj;
        }, {});
        var aantalOverschrijdingen = Object.keys(overschrijdingen).length;
        var gemiddelde = Object.values(serviceCountFiltered)
          .reduce((a, b) => a + b, 0) / (totaalaantal-aantalOverschrijdingen);
        return gemiddelde;
      },
      quarterResult(result,period) {
        return result.filter((item) => moment(item.a).toDate().getFullYear() == period.year && moment(item.a).quarter() == period.quarter);
      },
    },  
}
</script>